<template>
  <div class="wrapper" @touchmove.stop="">
    <slot />
    <div v-if="showClose" class="ico-close" @click="close"></div>
  </div>
</template>

<script>
export default {
  props: {
    showClose: Boolean
  },
  mounted() {
    this.$el.classList.add('fadeIn')
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
$anime: 0.2s ease-in;
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadeIn {
  animation: fadeIn $anime;
  opacity: 1;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.fadeOut {
  animation: fadeOut $anime;
  opacity: 0;
}
.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  font-size: 30px;
  background-color: rgba($color: #000000, $alpha: 0.68);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 100;
  touch-action: none;
  .ico-close {
    margin-top: 64px;
    width: 64px;
    height: 64px;
    background-image: url("~@/assets/ico/ico-close.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
}
</style>